import {
    SHOPCRATE_LANGUAGE
} from "../ShopCrateLocalization";

function priceFormatter(price) {
    return new Intl.NumberFormat(SHOPCRATE_LANGUAGE, { style: "currency", currency: "EUR" }).format(price);
}

export default priceFormatter;
